import {
  WSElement,
  WSInfoBox,
  WSList,
  WSTable,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { PGLI_KEY, PLAN_DETAILS } from "../../../utils/constants";
import { WS_LINKS } from "../../../../../types/wsLinks";

const { eligibleProfessionLabel } = PLAN_DETAILS[PGLI_KEY];

export const AboutPGLI: React.FC<{}> = ({}) => {
  type CoverageRow = { label: string; value: string };

  const rows: CoverageRow[] = [
    {
      label: "Professional Liability - Each Claim",
      value: "Up to $1,000,000"
    },
    {
      label: "Professional Liability - Aggregate",
      value: "Up to $2,000,000 (total per year)"
    },
    {
      label: "General Liability - Each Occurrence",
      value: "Up to $1,000,000"
    },
    {
      label: "General Liability - General Aggregate",
      value: "Up to $2,000,000 (total per year)"
    }
  ];

  return (
    <WSElement>
      <WSText.Paragraph weight="medium" mb="XL">
        About
      </WSText.Paragraph>
      <WSList gap="S" mb="L">
        <WSInfoBox title="What is it?" icon="bulb">
          Get comprehensive liability protection designed for{" "}
          <b>{eligibleProfessionLabel}.</b> This master policy combines two
          essential coverages into one streamlined package, helping you meet
          client requirements and protect your business instantly.
        </WSInfoBox>
        <WSInfoBox
          title="What does is cover?"
          icon="shield-check-fill"
          theme="neutral"
        >
          <b>Professional Liability (Errors & Omissions):</b> Protects you if a
          client claims your professional mistakes, negligence, or failure to
          deliver services caused them a financial loss. This covers legal
          defense costs and potential settlements.
          <br />
          <br />
          <b>General Liability:</b> Covers claims of third-party bodily injury
          (e.g., a slip-and-fall at an inspection site) or property damage
          caused by your business operations.
          <WSElement my="L">
            <WSText.ParagraphSm weight="medium" mb="NONE">
              Policy highlights
            </WSText.ParagraphSm>
          </WSElement>
          <WSTable<CoverageRow>
            tableData={rows.map(r => ({ id: r.label, data: r }))}
            columns={[
              {
                config: {
                  gridTemplateSizeMax: "999px"
                },
                renderFunction: ({ data }) => (
                  <WSText.ParagraphSm weight="medium">
                    {data.label}
                  </WSText.ParagraphSm>
                )
              },
              {
                config: {
                  gridTemplateSizeMax: "999px"
                },
                renderFunction: ({ data }) => (
                  <WSText.ParagraphXs weight="light">
                    {data.value}
                  </WSText.ParagraphXs>
                )
              }
            ]}
          />
        </WSInfoBox>

        <WSInfoBox icon="link">
          <a
            target="_blank"
            rel="noreferrer"
            href={WS_LINKS.wingspanPLGLPolicy}
          >
            View full policy details
          </a>
          <br />
          <b>Insurer: </b>Underwritten by Evanston Insurance Company (a Markel
          company).
        </WSInfoBox>
      </WSList>
    </WSElement>
  );
};
